(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["legacyCharmBlocks"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.getElementById('videoModal');
    var span = document.getElementsByClassName('close-modal')[0];
    var videoPlayer = document.getElementById('videoModal').querySelector('video');
    var videoSource = document.getElementById('videoSource');

    console.log("Setup");
    function openModalAndPlayVideo(videoUrl) {
      videoSource.src = videoUrl;
      videoPlayer.load();
      videoPlayer.play();
      modal.style.display = 'block';
    }

    var triggers = document.querySelectorAll('.video-trigger');
    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var videoUrl = this.getAttribute('data-video-url');
        openModalAndPlayVideo(videoUrl);
      });
    });

    span.onclick = function() {
      modal.style.display = 'none';
      videoPlayer.pause();
    };

    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = 'none';
        videoPlayer.pause();
      }
    };
  });

  } catch(e) { console.error(e); }
})();
})();
